import GTPagination from './src/pagination';


export default GTPagination;
